import { showReportDialog } from "@sentry/react";
import { usePlosTranslations } from "../../contexts/PlosTranslationsContext";
import { contentMain, pagePadding } from "../../layouts";
import { reportButton } from "./styles.css";

const ErrorFallback = ({ eventId }: { eventId?: string }) => {
  const { errorFallback } = usePlosTranslations();
  const canReportToSentry = import.meta.env.VITE_SENTRY_ENVIRONMENT && eventId;
  return (
    <div className={pagePadding}>
      <div className={contentMain}>
        <h2>{errorFallback.title}</h2>
        <p>{errorFallback.errorMessage}</p>
        {canReportToSentry && (
          <div>
            <p>{errorFallback.reportMessage}</p>
            <button
              onClick={() => showReportDialog({ eventId })}
              className={reportButton}
            >
              {errorFallback.reportButton}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ErrorFallback;
